import {useCallback, useEffect, useRef, useState} from "react";

const useDashboardModalState = ({payload, isReady, onClose}) => {
    const [visiblePayload, setVisiblePayload] = useState(null);
    const dismissedPayloadRef = useRef(null);
    const onCloseRef = useRef(onClose);

    useEffect(() => {
        onCloseRef.current = onClose;
    }, [onClose]);

    useEffect(() => {
        if (!payload) {
            dismissedPayloadRef.current = null;
            setVisiblePayload(null);
            return;
        }

        if (!isReady || dismissedPayloadRef.current === payload) return;
        setVisiblePayload(payload);
    }, [isReady, payload]);

    const closeModal = useCallback(() => {
        dismissedPayloadRef.current = payload;
        setVisiblePayload(null);
        onCloseRef.current?.();
    }, [payload]);

    const open = Boolean(payload)
        && visiblePayload === payload
        && dismissedPayloadRef.current !== payload;

    return {
        open,
        closeModal,
        isPreparing: Boolean(payload) && !open && dismissedPayloadRef.current !== payload,
    };
};

export default useDashboardModalState;
